// @flow
import cn from 'classnames';
import React from 'react';

import { layoutCssVars } from '../stylesHelper';

import './style.pcss';

const withMixedLayout = (items: React$Element<'div'>[]) => {
  const getClassName = (index: number) => {
    switch (true) {
      case [1, 2].includes(index) || [2, 4].includes(items.length):
        return 'mixed-layout__item--2-columns';
      case index === 0:
        return 'mixed-layout__item--1-columns';
      default:
        return 'mixed-layout__item--3-columns';
    }
  };

  const getCardCustomStyles = (index: number) => {
    switch (true) {
      case [1, 2].includes(index) || [2, 4].includes(items.length):
        return layoutCssVars.MIDDLE;
      case index === 0:
        return layoutCssVars.LARGE;
      default:
        return layoutCssVars.SMALL;
    }
  };

  return (
    <div className='mixed-layout'>
      {items.map((item, index) => (
        <div
          key={item.key}
          style={getCardCustomStyles(index)}
          className={cn('mixed-layout__item', getClassName(index))}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default withMixedLayout;
